module.exports = __webpack_public_path__ + "img/code.a7a2f13f.png";